import { render, staticRenderFns } from "./NationalPatentApplicationTypeList.vue?vue&type=template&id=bb116560&"
import script from "./NationalPatentApplicationTypeList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentApplicationTypeList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentApplicationTypeList.vue?vue&type=style&index=0&id=bb116560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports